import { Stack, Tag, Typography } from '@omnipresentgroup/design-system';
import { PaymentMethod } from '@omnipresentgroup/types';

import {
  PaymentMethodCard,
  type PaymentMethodCardDetails,
} from './PaymentMethodCard';

const PAYMENT_METHODS: Record<PaymentMethod, PaymentMethodCardDetails> = {
  [PaymentMethod.MANUAL_BANK_TRANSFER]: {
    title: 'Manual bank transfer',
    description: 'Send money from my own bank account',
    iconName: 'Cash',
  },
  [PaymentMethod.CREDIT_CARD]: {
    title: 'Credit card',
    iconName: 'CreditCard',
    tag: (
      <Tag id={`${PaymentMethod.CREDIT_CARD}-tag`} intent="info">
        Coming soon
      </Tag>
    ),
    disabled: true,
  },
  [PaymentMethod.DIRECT_DEBIT]: {
    title: 'Direct debit',
    iconName: 'Calendar',
    tag: (
      <Tag id={`${PaymentMethod.DIRECT_DEBIT}-tag`} intent="info">
        Coming soon
      </Tag>
    ),
    disabled: true,
  },
};

type Props = {
  onPaymentMethodSelect: (method: PaymentMethod) => void;
  selectedPaymentMethod?: PaymentMethod;
};

export const PaymentMethodSelector = ({
  onPaymentMethodSelect,
  selectedPaymentMethod,
}: Props) => {
  return (
    <Stack gap="24" bg="primary" p="32">
      <Typography size="16" as="h4" weight="medium" hideParagraphSpacing>
        How do you wish to pay?
      </Typography>
      <Stack gap="16">
        {Object.entries(PAYMENT_METHODS).map(([key, value]) => {
          const method = key as PaymentMethod;
          return (
            <PaymentMethodCard
              key={key}
              paymentMethod={method}
              selected={selectedPaymentMethod === method}
              onClick={() => onPaymentMethodSelect(method)}
              {...value}
            />
          );
        })}
      </Stack>
    </Stack>
  );
};
